import { render, staticRenderFns } from "./intel_industry.vue?vue&type=template&id=4beec12e&scoped=true&"
import script from "./intel_industry.vue?vue&type=script&lang=js&"
export * from "./intel_industry.vue?vue&type=script&lang=js&"
import style0 from "./intel_industry.vue?vue&type=style&index=0&id=4beec12e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beec12e",
  null
  
)

export default component.exports